import { render } from "./Employees.vue?vue&type=template&id=2f577c72&ts=true"
import script from "./Employees.vue?vue&type=script&lang=ts"
export * from "./Employees.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__